import React, { useEffect, useState } from 'react';
import styled, { keyframes } from 'styled-components';
import { SERVER_URL } from '../../constants/url';


// 설문지 소개 페이지

const ContentWrap = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    margin-top: var(--sp-32);
`;
const StyledRadioBox = styled.div`
  &.radio-selectbox.selected label,
  &.chkbox-custom.selected label {
    background-color: var(--color-main-5);
    color: white;
    border-radius: var(--radius-12);
  }
`;
const QuestionTitle = styled.p`
    // display: flex;
    // align-items: center;
    // justify-content: center;
    font-size: var(--mo-fz-md);
    font-weight: var(--fz-weight-700);
    color: var(--color-main-gray);
    white-space: pre-wrap;
    text-align: center;
    position: sticky;
    top: var(--sp-52);
    width: 100%;
    padding: var(--sp-10) var(--sp-16);
    z-index: 100;
    background: var(--color-white);

    & .choice-type {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        margin-top: var(--sp-10);
        color: var(--color-main-5);

        & span {
            display: block;
            color: var(--color-main-gray);
            font-size: var(--mo-fz-smd);
            font-weight: var(--fz-weight-500);

            & b {
                font-size: var(--mo-fz-smd);
                color: var(--color-important);
            }
        }
    }
`;


const SelectListBox = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: var(--sp-12);
    width: 100%;
    margin-top: var(--sp-20);
    & > ul {
        display: flex; 
        flex-direction: column;
        gap: var(--sp-12);
        width: 100%;   
        & >  li {
            width: 100%;
        } & label {
            white-space: pre-wrap;
            text-align: center;
        }
    }
`;

const loadEffect3 = keyframes`
  0% {
    opacity: 0;
    transform: scale(0.95);
  }
  65% {
    opacity: 0.65;
    transform: scale(1.01);
  }
  85% {
    opacity: 0.85;
    transform: scale(0.98);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
`;

const AnimatedUl = styled.ul`
  display: flex; 
  flex-direction: column;
  gap: var(--sp-12);
  width: 100%;
  padding: 0 var(--sp-16);
  animation: ${loadEffect3} 0.5s ease-in-out;
    & li:first-child {
        & .imgbox {
            margin-top: var(--sp-10);
        }
    } 
//   &.select-img-listbox {
//     flex-wrap: wrap;
//     flex-direction: row;
//     gap: var(--sp-08) var(--sp-08);
//     max-width: 32rem;
//         & li {
//             width: calc(50% - var(--sp-08));
//         }
//   }      
`;


const ImgBoxCont = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: var(--sp-12);
    margin-top: var(--sp-38);
    gap: var(--sp-08);
        & div {
            overflow: hidden;
            width: 100%;
            border-radius: var(--radius-12);
            & img {
                display: block;
                width: 100%; 
                object-fit: contain;
            }
        }
        & .custom-survey-img-box {
            max-width: 75%;
        }
    &[data-img-box="main"] {
        margin-top: var(--sp-20);
    }            
`;

const ImgCopyright = styled.div`
    display: flex;
    flex-direction: column;
    margin-bottom: var(--sp-08);
    margin-top: var(--sp-60);
    padding-top: var(--sp-08);
    gap: var(--sp-08);
    border-top: 1px solid rgba(180, 184, 190, 0.7);
        & > p {
            font-size: var(--mo-fz-sm);
            font-weight: var(--fz-weight-700);
            color: var(--color-main-gray-5);
        }
        & ul li {
            position: relative;
            padding-left: var(--sp-18);
            line-height: 1.1;
                & p {
                    display: inline-block;
                    font-size: var(--mo-fz-sm);
                    font-weight: var(--fz-weight-700);
                    color: var(--color-main-gray-5);
                }
                & span {
                    word-break: break-all;
                    font-size: var(--mo-fz-sm);
                    font-weight: var(--fz-weight-400);
                    color: var(--color-main-gray-5);
                }    
            &:before {
                content: "";
                position: absolute;
                display: block;
                width: 3px;
                height: 3px;
                border-radius: 100%;
                background-color: var(--color-main-gray-5);
                top: var(--sp-08) ;
                left: var(--sp-08);
            }        
        }    
`;


const Boundary = styled.div`
    display: flex; 
    align-items: center; 
    justify-content: center; 
    position: relative;
    width: 100%;
    height: var(--sp-28);
    margin-top: var(--sp-32);
    margin-bottom: var(--sp-14);
    border-top: 1px solid var(--color-main-15);
    background-color: var(--color-main-25);

    &:before {
        content: "";
        position: absolute;
        top: 100%;
        left: 50%; 
        transform: translateX(-50%);
        width: 0;
        height: 0;
        border-left: 20px solid transparent;
        border-right: 20px solid transparent;
        border-top: 8px solid var(--color-main-25);
    }
    
    & span {
        font-size: var(--mo-fz-sm);
        color: var(--color-main-65);
        font-weight: var(--fz-weight-700);
    } 
`;


const StickyBoldWrap = styled.span`
  &.sticky {
    position: sticky;
    top: var(--sp-52);
    width: 100%;
    padding: var(--sp-10);
    z-index: 100;
    background: var(--color-white);
    display: inline-block;
    text-align: center;
  }
`;


const CostomSurveyMulti = ({surveyData, selectedValue, onChange, step }) => {
    const { qesitmNo, qesitmCn, cmpnoChisAt, cmpnoChisCd, cmpnoIemCo, qestAtchFileStr, qestAtchFileStrSub, options  } = surveyData;

    // cmpnoChisAt 가 '0' 이면 단일선택 | '1' 이면 복수선택
    //const isMulti = cmpnoChisAt === '1';
    //const isSubject = cmpnoChisAt === '0';

    //no-imgage 관련
    const [imgError, setImgError] = useState(false);
    const [optionImgErrors, setOptionImgErrors] = useState({});

    const BoldText = ({ text, className }) => {
        // text가 문자열인지 확인
        if (!text || typeof text !== 'string') {
            return null;
        }

        const parts = text.split(/(\*[^*]+\*|\[[^\]]+\])/g);

        return (
            <StickyBoldWrap className={className}>
                {parts.map((part, idx) => {
                    if (part.startsWith('*') && part.endsWith('*')) {
                        const boldText = part.slice(1, -1);
                        return <strong key={idx}>{boldText}</strong>;
                    }
                    if (part.startsWith('[') && part.endsWith(']')) {
                        const colorText = part;
                        return <span key={idx} style={{ color: '#E55151' }}>{colorText}</span>;
                    }

                    return part.split('\n').map((line, i) => (
                        <React.Fragment key={`${idx}-${i}`}>
                            {line}
                            {i < part.split('\n').length -1 && <br />}
                        </React.Fragment>
                    ));
                })}
            </StickyBoldWrap>
        );
    };

    const getLimitState = () => {
        const selected = selectedValue || [];
        const count = selected.length;

        // 복수선택 옵션 ( cmpnoChisCd : MN | MX | PE ) -> 복수옵션별 복수선택수 cmpnoIemCo 에 따른 제한사항이 필요하다면..
        // 복수옵션코드별로 처리할 것
        if ( cmpnoChisAt === "1" && cmpnoChisCd !== undefined) {
            // MX: 최대 개수 제한
            if (cmpnoChisCd === 'MX') {
                return {
                    limit: cmpnoIemCo,
                    reached: count >= Number(cmpnoIemCo)
                };
            }

            // PE: 정확한 개수 제한
            if (cmpnoChisCd === 'PE') {
                return {
                    limit: cmpnoIemCo,
                    reached: count >= Number(cmpnoIemCo)
                };
            }
            // MN: 최소 개수 (제한 없음, 유효성 검사만 필요)
            if (cmpnoChisCd === 'MN') {
                return {
                    limit: cmpnoIemCo,
                    reached: false // 최소 개수는 선택 제한이 아님
                };
            }


            // return {
            // limit: cmpnoIemCo,
            // reached: count >= Number(cmpnoIemCo)
            // };
        }

        // 기본값: 제한 없음
        return {
            limit: null,
            reached: false
        };
    };

    const isOptionDisabled = (value) => {
        const selected = selectedValue || [];
        const { reached } = getLimitState();

        // 아직 제한 채워지지 않았으면 모두 선택 가능
        if (!reached) return false;

        // 이미 선택된 것은 해제 가능해야 함
        if (selected.includes(value)) return false;

        // 제한 도달 후 → 다른 항목 선택 금지
        return true;
    };


    const getChoiceGuideText = (cdId, count) => {
        switch (cdId) {
            case 'MX':
                return <>(최대 개수 <b>{count}</b> 개를 선택해주세요.)</>;
            case 'MN':
                return <>(최소 개수 <b>{count}</b> 개를 선택해주세요.)</>;
            case 'PE':
                return <>(정확한 개수 <b>{count}</b> 개를 선택해주세요.)</>;
            default:
                return '';
        }
    };

    // 노이미지 핸들러
    const handleMainImageError = () => {
        setImgError(true);
    };

    const handleOptionImageError = (itemOrdr) => {
        setOptionImgErrors(prev => ({
            ...prev,
            [itemOrdr]: true
        }));
    };


    return (

        <ContentWrap>

            {/* 질문 내용 */}
            <QuestionTitle>
                <BoldText text={qesitmCn || ''} />

                {cmpnoChisAt === "0" ?
                    <p className='choice-type'>[ 단일 선택 ]</p>
                :
                    <p className='choice-type'>[ 복수 선택 ]
                            <span>
                            {getChoiceGuideText(cmpnoChisCd, cmpnoIemCo)}
                        </span>
                    </p>
                }

            </QuestionTitle>

            { qestAtchFileStrSub !== undefined && (
                <ImgBoxCont className='imgbox' data-img-box="main">
                    <div>
                        {imgError ? (
                                <img
                                    src={`/images/common/no_img.png`}
                                    alt={`no-img`}
                                />
                            ) : (
                                <img
                                    src={`${SERVER_URL}/cmm/fms/getImage?atchFileStr=${qestAtchFileStr}&fileSn=${qestAtchFileStrSub}`}
                                    alt={`option-${qesitmCn}`}
                                    onError={handleMainImageError}
                                />
                            )
                        }

                    </div>

                </ImgBoxCont>
            )}

            <Boundary>
                <span>답변 선택</span>
            </Boundary>

            {/* 선택 리스트 */}
             { options?.length > 0 && (
            <SelectListBox>
                <AnimatedUl key={step} className={ qestAtchFileStrSub !== undefined && 'select-img-listbox'}>
                    {options.map((opt, index) => {
                        const inputId = `${qesitmNo}_${index}`;
                        const isChecked = selectedValue.includes(opt.itemOrdr);
                        return (
                            <li key={opt.itemOrdr}>
                                <div>

                                    { opt?.itemAtchFileStrSub !== undefined && (
                                        <ImgBoxCont className='imgbox'>
                                            <div className='custom-survey-img-box'>
                                                {optionImgErrors[opt.itemOrdr] ? (
                                                    <img
                                                        src={`/images/common/no_img.png`}
                                                        alt={`no-img`}
                                                    />
                                                ) : (
                                                    <img
                                                        src={`${SERVER_URL}/cmm/fms/getImage?atchFileStr=${opt.itemAtchFileStr}&fileSn=${opt.itemAtchFileStrSub}`}
                                                        alt={`option-${qesitmCn}`}
                                                        onError={() => handleOptionImageError(opt.itemOrdr)}
                                                    />
                                                )}
                                            </div>
                                        </ImgBoxCont>
                                    )}



                                        <StyledRadioBox
                                            className={`${cmpnoChisAt === "1" ? "chkbox-custom" : "radio-selectbox"} ${isChecked ? "selected" : ""}`}
                                            data-chkbox={cmpnoChisAt === "1" && "list-btn"}
                                        >
                                            <input
                                            type={cmpnoChisAt === "1" ? "checkbox" : "radio"}
                                            id={inputId}
                                            name={qesitmNo}
                                            value={opt.value}
                                            checked={
                                                cmpnoChisAt === "1"
                                                    ? selectedValue?.includes(opt.value) || false
                                                    : selectedValue?.[0] === opt.value || false
                                            }
                                            onChange={() => {
                                                if (cmpnoChisAt === "1") {
                                                    // 복수 선택: 기존 로직 유지
                                                    onChange(null, opt.value);
                                                } else {
                                                    // 단일 선택: 배열을 새로 만들어서 하나만 선택
                                                    onChange(qesitmNo, [opt.value]);
                                                }
                                            }}
                                            disabled={cmpnoChisAt === "1" && isOptionDisabled(opt.value)}
                                            />
                                            <label htmlFor={inputId}>
                                            <span>
                                               {opt.label && Array.isArray(opt.label)
                                                ? opt.label.map((part, idx) => (
                                                    <span
                                                    key={idx}
                                                    style={{
                                                        fontWeight: part.weight === "bold" ? "700" : "400",
                                                        whiteSpace: 'pre-wrap' // \n 줄바꿈 처리
                                                    }}
                                                    >
                                                    {part.text}
                                                    </span>
                                                ))
                                                : opt.label}
                                            </span>

                                            </label>
                                        </StyledRadioBox>


                                </div>
                            </li>
                        );
                    })}
                </AnimatedUl>
            </SelectListBox>
            )}

                 {surveyData.copyright && (
                    <ImgCopyright>
                        <p>이미지 출처</p>
                        <ul>
                            {surveyData.copyright.map((copy, idx) => (
                                <li key={idx}>
                                    {copy.tit && (<p>{copy.tit}: </p>)}

                                    <span> {copy.url}</span>
                                </li>
                            ))}
                        </ul>
                    </ImgCopyright>
                 )}





        </ContentWrap>

    );
};

export default CostomSurveyMulti;
